export const NAV_LINKS = [
  { label: 'Tentang WBS', href: '#tentang' },
  { label: 'Cara Kerja', href: '#cara-kerja' },
  { label: 'Fitur & Keamanan', href: '#fitur' },
  { label: 'FAQ', href: '#faq' },
]

export const FOOTER_NAV_LINKS = [
  ...NAV_LINKS.map(link => ({ ...link, href: resolvePublicHref(link.href) })),
  { label: 'Kebijakan Privasi', href: '/kebijakan-privasi' },
  { label: 'Syarat & Ketentuan', href: '/syarat-ketentuan' },
  { label: 'Aksesibilitas', href: '/aksesibilitas' },
]

/** Anchor links from non-home pages must include / prefix. */
export function resolvePublicHref(href, isHomePage = false) {
  if (href.startsWith('#')) {
    return isHomePage ? href : `/${href}`
  }
  return href
}
